import React, { useState } from 'react';
import { Reveal } from '../ui/Reveal';
import { ReviewCard } from '../ui/ReviewCard';

export const Reviews = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const reviewsData = [
    {
      quote: "Thank you for creating such an amazing platform. I truly appreciate the excellent server performance, the impressive website contrast, and the engaging landing page design. The pop-up messages are highly effective and user-friendly. What stands out most is how well it serves educational institutes by providing customized updates right at users' fingertips. Your thoughtful development has created a professional, accessible, and impactful digital experience.",
      name: "Prof. Jagadeesh Alkur",
      title: "Chief Mentor, V Academy Raichur"
    },
    {
      quote: "Working with Nismay Studios to launch the Bhavani Tours & Travels website was a fantastic experience. They perfectly captured our brand and created a clean, responsive site that makes exploring our tour packages and booking trips effortless. Communication was prompt, and they delivered right on time. If you need top-tier web design, look no further than Nismay Studios!",
      name: "Basavaraj Nayak",
      title: "Owner, Bhavani Tours & Travels Yadgir"
    }
  ];

  const handlePrev = () => {
    setCurrentIndex((prevIndex) => 
      prevIndex === 0 ? reviewsData.length - 1 : prevIndex - 1
    );
  };

  const handleNext = () => {
    setCurrentIndex((prevIndex) => 
      prevIndex === reviewsData.length - 1 ? 0 : prevIndex + 1
    );
  };

  return (
    <section className="sec" id="reviews">
      <Reveal><div className="slabel">Credibility</div></Reveal>
      <Reveal delay="1"><h2 className="stitle">Ratings & <em>Reviews</em></h2></Reveal>

      <Reveal delay="1.5">
        <div className="google-card-wrapper" style={{ marginBottom: '2rem' }}>
           {/* ... Keep your existing Google Card Code here ... */}
           <div className="google-card">
            <div className="gc-header">
              <div className="gc-title-wrap">
                <img src="/assets/ns.png" alt="Nismay Studios Logo" className="gc-brand-logo" />
                <h3 className="gc-title">Nismay Studios</h3>
              </div>
              <p className="gc-category">Software company in Yadgiri, Karnataka</p>
              <div className="gc-rating-row">
                <span className="gc-rating-num">5.0</span>
                <span className="gc-stars">★★★★★</span>
                <a href="https://g.page/r/CZPgcbu3wv_UEBM/review" target="_blank" rel="noreferrer" className="gc-review-link">
                  Google Reviews
                </a>
              </div>
              <div className="gc-header-hours">
                <span className="gc-hours-icon">⏰</span>
                <p><strong>Hours:</strong> Open 24 hours</p>
              </div>
            </div>
            <div className="gc-actions">
              <a href="#top" className="gc-act-btn" onClick={(e) => { e.preventDefault(); window.scrollTo({ top: 0, behavior: 'smooth' }); }}>
                <div className="gc-icon">🌐</div>
                <span>Website</span>
              </a>
              <a href="https://maps.google.com/?q=Mayur+Nivas,+Yadgiri,+Karnataka+585201" target="_blank" rel="noreferrer" className="gc-act-btn">
                <div className="gc-icon">🗺️</div>
                <span>Directions</span>
              </a>
              <a href="tel:+916366605358" className="gc-act-btn">
                <div className="gc-icon">📞</div>
                <span>Call</span>
              </a>
              <a href="mailto:info@nismaystudios.in" className="gc-act-btn">
                <div className="gc-icon">✉️</div>
                <span>Mail</span>
              </a>
            </div>
            <div className="gc-footer-cta">
              <a href="https://g.page/r/CZPgcbu3wv_UEBM/review" target="_blank" rel="noreferrer" className="gc-write-btn">
                ✏️ Write a review
              </a>
              <div className="gc-write-btn gc-disabled-element">
                <span>📸 Add a photo</span>
              </div>
            </div>
          </div>
        </div>
      </Reveal>

      {/* Responsive Carousel */}
      <Reveal delay="2">
        <div className="reviews-carousel">
          {/* Desktop Left Arrow */}
          <button onClick={handlePrev} className="nav-arrow desktop-arrow" aria-label="Previous Review">
            &#10094;
          </button>

          {/* Current Review Card - Added key={currentIndex} here */}
          <div className="review-content" key={currentIndex}>
            <ReviewCard review={reviewsData[currentIndex]} />
          </div>

          {/* Desktop Right Arrow */}
          <button onClick={handleNext} className="nav-arrow desktop-arrow" aria-label="Next Review">
            &#10095;
          </button>
        </div>
        
        {/* Mobile Controls & Indicator Dots */}
        <div className="carousel-controls">
          <button onClick={handlePrev} className="nav-arrow mobile-arrow" aria-label="Previous Review">
            &#10094;
          </button>

          <div className="carousel-dots">
            {reviewsData.map((_, idx) => (
              <span 
                key={idx} 
                className={`dot ${currentIndex === idx ? 'active' : ''}`}
              />
            ))}
          </div>

          <button onClick={handleNext} className="nav-arrow mobile-arrow" aria-label="Next Review">
            &#10095;
          </button>
        </div>
      </Reveal>
    </section>
  );
};